import { Component, OnInit, AfterViewInit, NgZone } from '@angular/core';
import { IwService } from 'src/app/services/iw.service';
import { ActivatedRoute, Router } from '@angular/router';
import { base_https_url, SBICARDTheme, CATALOG_VERBIAGE, BRAND_APPROVED_ERRORS, excludedReferPICardsCataloguePage, REDIRECT_SWIFT_URL } from 'src/app/config/app-settings.config';
import { ThemeService } from 'src/app/services/theme.service';
import { cardAnimations } from 'src/app/utilities/animations';
import cssVars from 'css-vars-ponyfill';
import { CatalogueService } from '../../services/catalogue.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { LoaderService } from 'src/app/services/loader.service';
import { xmlToJson, getDeviceSize } from '../../utilities/utilities.file';
import { element } from '@angular/core/src/render3';
//import { OutgoingMessage } from 'http';
declare var _satellite: any;
declare var catalogue_card_click: Function;
declare var virtual_page_load: Function;
//declare var analytics: any;
@Component({
  selector: 'app-catalogue',
  templateUrl: './catalogue.component.html',
  styleUrls: ['./catalogue.component.scss'],
  animations: [cardAnimations]
})
export class CatalogueComponent implements OnInit {
  partnerLables: any;
  partnerSelected: any;
  partnerCardDetails: any;
  partnerVariations: any;
  bannerUrl: any;
  themeParam: any;
  responseTheme: any;
  themeObj: any;
  domainUrl: any;
  trackretreiveEnabled: boolean;
  trackRetrieveHeading: any;
  showAllCardsFlagFromDcr: boolean = true;
  cardArrayDcr: any;
  catalogLabel: any = CATALOG_VERBIAGE;
  errorLabel: any = BRAND_APPROVED_ERRORS;
  errorMsg: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  partnerExpiryDate: any;
  currentDate: any = new Date();
  partnerDetails: any;
  isMobile: boolean;
  carddata: any;
  cardCatogoriesName: any = [];
  selectedCatoryName: any;
  selectedCardData: any = [];
  allCardData: any = [];
  totalCardsList: any = [];
  https_url: any;
  cardVisibleData: any;
  cardCount: any;
  pageHeading: any;
  excludedCards: any = excludedReferPICardsCataloguePage;
  totalcardCount: any;
  eapplyCataloguePageLabels: any;
  offerLabels: any;
  cardErrorBlock: boolean = false;
  showCompareDialog: boolean = false;
  showCompareBox: boolean = false;
  mainBlock: boolean = false;
  selectedIndex: any;
  seletedCategory: any;
  knowMoreContainer: any = [];
  knowMoreData: any = false;
  knowMoreorder: Number;
  extraknowMoreData: any = [];
  CompareCardData: any = [];
  isAnimationDisabled: boolean;
  viewMoreBtnVisible: boolean = true;
  viewMoreLessVisible: boolean = false
  // piEapplyBancaEnabled: boolean =false;
  // showLoader: boolean = true;
  customCards: any;
  customCardsName: any = [];
  finalCards: any;
  isEapplyBanca: boolean = false;
  isEapplyCustom:boolean = false;
  mobileViewOnly:boolean;
  isBanca: any;
  dcrCardUrlMapping: any;
  gemId1: any;
  gemId2: any;
  eligibleCardList: any;
  themeString: any;
  redirectToSwift: boolean = false;
  constructor(
    private iw: IwService,
    private route: ActivatedRoute,
    private themeService: ThemeService,
    private catalogueService: CatalogueService,
    private ngZone: NgZone,
    private router: Router,
    private sharedData: SharedServiceService,
    private _sanitizer: DomSanitizer,
    private loaderService: LoaderService

  ) {
    let defaultUrl = sessionStorage.getItem('defaultUrl');
    //console.log("let defaultUrl ==>>"+defaultUrl);
    defaultUrl ? history.replaceState('', '', defaultUrl) : true;
    this.partnerDetails = this.themeService.partnerDetails;
    this.partnerCode = this.themeService.partnerCode;
    //console.log("this.partnerCode is ==>"+this.partnerCode);
    this.partnerExpiryDate = this.themeService.partnerExpiryDate;
  }
  transform(style) {
    return this._sanitizer.bypassSecurityTrustStyle(style);
  }
  public sanitizeImage(image: string) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${base_https_url}${image})`);
  }

  ngOnInit() {
    this.selectedIndex = -1;
    this.knowMoreData=false;
    this.loaderService.show();
    if (getDeviceSize() === 'small') {
      this.isMobile = true;
    } 
    window.onresize = (e) => {
      this.ngZone.run(() => {
        if (getDeviceSize() === 'small') {
          this.isMobile = true;
        } else {
          
          this.isMobile = false;
        }
      });
    };
    this.sharedData.retrievedApplicationResponse = null;
    let defaultUrl = sessionStorage.getItem('defaultUrl');
    defaultUrl ? history.replaceState('', '', defaultUrl) : true;
    // (document.documentElement || document.body).scrollTop = 0;
    document.getElementById('sbicard') ? document.getElementById('sbicard').scrollTop = 0 : (document.documentElement || document.body).scrollTop = 0;
    //console.log(this.containerType);
    this.domainUrl = base_https_url;
    // this.bannerUrl = base_https_url;
    // this.partnerLables = this.iw.getPartnerCardDetailsDcr();
    //console.log(this.partnerLables);

    this.route.queryParams.subscribe(query => {
      if (query) {
        this.isBanca = query.CHN && query.CHN == '901' ? true : false;
        const theme = query.theme;
        this.themeString = query.theme;
        this.gemId1 = query.GEMID1;
        this.gemId2 = query.GEMID2;
        //const channelcode = query.CHN;
        //if ((theme && channelcode) || theme) {
        if (theme) {
          this.partnerLables = this.iw.getPartnerCardDetailsDcr(theme);
         // console.log("this.partnerLables value is==>" + JSON.stringify(this.partnerLables));
          if (this.partnerLables.partner.length > 1) {
            this.partnerLables.partner.forEach(element => {
              if (element.partner_name == theme) {
                this.partnerSelected = element;
               // console.log("this.partnerSelected value is ==>" + JSON.stringify(this.partnerSelected));
              }
            });
            this.mobileViewOnly =  this.partnerSelected.mobile_only == 'yes' ? true : false;
            this.partnerVariations = this.partnerSelected.variation;
            //console.log("this.partnerVariations ==>"+JSON.stringify(this.partnerVariations));
          }
          else {
            this.partnerSelected = this.partnerLables.partner;
            this.partnerVariations = this.partnerSelected.variation;
          }
          if (this.partnerVariations) {
            //this.bannerUrl=`${base_https_url}${this.partnerSelected[0].Banner_image}`;
            this.partnerCardDetails = this.partnerVariations;
            //console.log("this.partnerCardDetails ===>>>" +JSON.stringify(this.partnerCardDetails));
            this.trackretreiveEnabled = this.partnerVariations.heading_with_multiple_cards.track_and_retrieve == 'yes' ? true : false;
            this.trackRetrieveHeading = this.partnerVariations.heading_with_multiple_cards.heading;
            this.pageHeading = this.partnerVariations.heading_with_multiple_cards.page_heading;
            //this.showAllCardsFlagFromDcr =  this.partnerVariations.heading_with_multiple_cards.show_all_cards =='yes'  ? true :false;
            this.cardArrayDcr = this.partnerVariations.heading_with_multiple_cards.card;
            //this.piEapplyBancaEnabled = channelcode =='901' ? true :false;
            //this.setPartnerData();
            this.loaderService.hide();

            // this.setThemeByParam(theme);
            this.mainBlock = true;
            this.loadPageData();
            this.isAnimationDisabled = true;
            if (!this.isMobile && this.mobileViewOnly) {
              this.errorMsg = true;
              this.errorMsg = this.catalogLabel.incorrectUrl;
            }
          } else {
            this.errorMsg = this.catalogLabel.incorrectUrl;
          }
        }
        //console.log(this.partnerCardDetails);
        //console.log(this.bannerUrl);
      }
    });
    if (this.partnerDetails && this.containerType) {
      // if(this.partnerCode && this.containerType && this.partnerExpiryDate.setHours(0,0,0,0) <= this.currentDate.setHours(0,0,0,0)){
      if (this.partnerCode && this.containerType) {
        this.partnerLables = this.iw.getPartnerCardDetailsDcr(this.partnerCode);
        this.partnerSelected = this.partnerLables.filter(value => value.partner_text == this.partnerCode);
        //console.log(this.partnerSelected);
        if (this.partnerSelected[0]) {
          this.bannerUrl = `${base_https_url}${this.partnerSelected[0].Banner_image}`;
          this.partnerCardDetails = this.partnerSelected[0].card;
          this.loaderService.hide();
          this.errorMsg = false;
          // this.setThemeByParam(this.partnerCode);
        }
      } else if (this.partnerCode && this.containerType && this.partnerExpiryDate.setHours(0, 0, 0, 0) > this.currentDate.setHours(0, 0, 0, 0)) {
        this.errorMsg = this.catalogLabel.partnerExpiryError;
      }
      // else {
      //   this.errorMsg = this.catalogLabel.incorrectUrl;
      // }
    }

    //history.pushState('','','https://staticuat.sbicard.com');

    
  }
  

  ngAfterViewInit() {

    this.loaderService.hide();
    let defaultUrl = sessionStorage.getItem('defaultUrl');
    defaultUrl ? history.replaceState('', '', defaultUrl) : true;
  }

  setThemeByParam(theme) {
    this.themeParam = theme;
    //console.log(this.themeParam);
    this.getThemeFromService(theme);
    this.themeService.themeParam = this.themeParam;
  }

  getThemeFromService(theme) {
    this.themeService.getThemeData(theme).subscribe((result: any) => {
      if (result) {
        if (result.partner_id && result.partner_id === theme) {
          this.responseTheme = result;
          this.themeObj = this.responseTheme;
          this.themeService.themeObj = this.themeObj;
          this.themeService.setThemePage(this.themeObj);
          cssVars({
            rootElement: document.getElementById('spa-content'),
            variables: this.themeObj
          });//Theme change for IE 
        } else {
          // this.errorMsg = 'JSON not found';
          this.themeService.setThemePage(SBICARDTheme);
          cssVars({
            rootElement: document.getElementById('spa-content'),
            variables: SBICARDTheme
          });//Theme change for IE 
        }
      } else {
        // this.errorMsg = 'JSON error';
        this.themeService.setThemePage(SBICARDTheme);
        cssVars({
          rootElement: document.getElementById('spa-content'),
          variables: SBICARDTheme
        });//Theme change for IE 
      }
    },
      (error) => {
        // this.errorMsg = 'Service not available';
        this.themeService.setThemePage(SBICARDTheme);
        cssVars({
          rootElement: document.getElementById('spa-content'),
          variables: SBICARDTheme
        });//Theme change for IE 
      }
    );
  }

  trackApp() {
    this.router.navigate(['/', 'track-app-partner'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType ? true : false });
  }

  loadPageData() {
    this.https_url = base_https_url;
    this.eapplyCataloguePageLabels = JSON.parse(JSON.stringify(this.iw.geteapplyFormLabelDcr().dcrContent.root)).eapply_refer;
    this.offerLabels = JSON.parse(JSON.stringify(this.eapplyCataloguePageLabels)).offerDetails;
    //console.log(this.offerLabels);
    this.getAllCardDataLocal();

  }
  getAllCardData() {
    this.carddata = this.catalogueService.getAllCardsJSON();
    this.setCardData();
  }
  setCardData() {
    if (this.showAllCardsFlagFromDcr) {
      this.carddata.cardTypes.forEach(element => {
        if (element.name != 'Banking Partnership' && element.name != 'Business') {
          this.cardCatogoriesName.push(element);
          //this.customCardsName.push(element);
          this.allCardData.push(element.cards);
        }
        this.cardCatogoriesName.unshift({
          name: 'All',
          cImage: '/sbi-card-en/assets/media/images/personal/credit-cards/card-category-image/re_all.svg'
        });
        this.manipulateCardData();
      })
    }
  }

  getAllCardDataLocal() {
    this.iw.getDcrXmlCardReponse().subscribe((res: any) => {
      if (res) {
        let convertedjson = res;
        let xmlJSON, xmlDoc;
        let parser = new DOMParser();
        xmlDoc = parser.parseFromString(convertedjson, "text/xml");
        xmlJSON = xmlToJson(xmlDoc);
        let parsedJSON;
        if (xmlJSON.hasOwnProperty('root')) {
          parsedJSON = JSON.parse(xmlJSON.root.json);
          //console.log("parsedJSON ==>"+parsedJSON);
        } else {
          this.cardErrorBlock = true;
        }
        if (parsedJSON) {
          this.carddata = JSON.parse(xmlJSON.root.json);
          if (!this.cardArrayDcr.length) {
            this.cardArrayDcr = [this.cardArrayDcr];
          }
          this.cardArrayDcr
          this.carddata.cardTypes.forEach(element => {
            this.cardArrayDcr.forEach(items => {

            
              let removeStrSpecial = items.card_category.replace(/&amp;/g, '&');
              if (element.name == removeStrSpecial && items.show_all_cards == 'isEapply') {
                this.isEapplyBanca = false;
                this.cardCatogoriesName.push(Object.assign(element, {'isEapplyBancaCatorgy':this.isEapplyBanca}))
                this.allCardData.push(Object.assign(element.cards, {'isEapplyBancaCatorgy':this.isEapplyBanca}));                
              }

              //Added for PIBanca starts
              else if (element.name == removeStrSpecial && items.show_all_cards == 'isEapplyBanca') {
                this.isEapplyBanca = true;
                this.cardCatogoriesName.push(Object.assign(element, {'isEapplyBancaCatorgy':this.isEapplyBanca}))
                this.allCardData.push(Object.assign(element.cards, {'isEapplyBancaCatorgy':this.isEapplyBanca}));
              }
              else if (element.name == removeStrSpecial && items.show_all_cards == 'custom') {
                this.isEapplyCustom = true;
                this.cardCatogoriesName.push(Object.assign(element, {'isEapplyCustomCatorgy':this.isEapplyCustom}))
                this.allCardData.push(Object.assign(element.cards, Object.assign({'isEapplyCustomCatorgy':this.isEapplyCustom},{'cusotmCardsList':items.card_list})));              
              }
              // if (element.name == removeStrSpecial && items.show_all_cards == 'custom') {
              //   console.log("Customs are");
              //   this.customCards = items.card_list;
              //   if (this.customCards && this.customCards.length > 1 || this.customCards!= 'undefined') {
              //     console.log("More");
              //     // this.cardCatogoriesName.push(element);
              //       this.allCardData.push(element.cards);
              //     });
              //   } else {
              //     console.log("less");
              //     // this.cardCatogoriesName.push(element);
              //     // this.allCardData.push(element.cards);
              //   }
              // }/     this.customCards.forEach(element => {
              //       this.cardCatogoriesName.push(element);
            


              //Added for PIBanca ends
            });
          });
          this.cardCatogoriesName.unshift({
            name: 'All',
            cImage: '/sbi-card-en/assets/media/images/personal/credit-cards/card-category-image/re_all.svg'
          });
          this.manipulateCardData();

        } else {
          this.cardErrorBlock = true;
        }

      }
    },
      (error) => {
        this.cardErrorBlock = true;
      })
  }
  manipulateCardData() {
    this.totalcardCount = 0;
    let totalCardsArray = [];
    this.allCardData.forEach(ele => {
      totalCardsArray.push(
        Object.assign(
          ele[0].details,
          {
            'isEapplyBancaCatorgy':ele.isEapplyBancaCatorgy,
          'isEapplyCustomCatorgy':ele.isEapplyCustomCatorgy,
          'cusotmCardsList':ele.cusotmCardsList
        }
        ));
    })
    let finalAllCardsData = [];
    totalCardsArray.forEach(ele => {
      ele.forEach(element => {
        if(ele.isEapplyBancaCatorgy ==true && element.isEapplyBanca == 'yes' && element.isVisibleOnWebsite == 'yes' && !this.excludedCards.includes(element.name)) {
          finalAllCardsData.push(element);
        } else if(ele.isEapplyBancaCatorgy ==false && element.isEapply == 'yes' && element.isVisibleOnWebsite == 'yes' && !this.excludedCards.includes(element.name)){
          finalAllCardsData.push(element);
        } 
        else if(ele.isEapplyCustomCatorgy ==true && ele.isEapplyCustomCatorgy !=undefined && ele.cusotmCardsList) {
          if(ele.cusotmCardsList.length >1) {
            ele.cusotmCardsList.forEach(cnt => {
              let dcrpath = cnt.card_dcr_path.replace('/shared/templatedata/product/card/data/sbi-card-en/','')
              if(element.path == dcrpath) {
                finalAllCardsData.push(element);
              } 
            })
        } else {
            let dcrpath = ele.cusotmCardsList.card_dcr_path.replace('/shared/templatedata/product/card/data/sbi-card-en/','')
            if(element.path == dcrpath) {
              finalAllCardsData.push(element);
              }  
          }
        }        
      });

    })
    this.totalCardsList = finalAllCardsData;
    this.totalcardCount = this.totalCardsList.length;
    this.selectedCardData = this.totalCardsList;
    this.cardCount = this.totalcardCount;
    this.selectedCatoryName = 'All Cards';
    this.seletedCategory = 'All';
    if(this.cardArrayDcr.length <2){
      this.selectedCatoryName = this.cardArrayDcr[0].card_category;
    this.seletedCategory = this.cardArrayDcr[0].card_category;
    }

  }
  catogoryCardData(items) {
    let catogoryCardData = [];
    items.cards[0].details.forEach(element => {
      // if(this.piEapplyBancaEnabled) {
      //   if(element.isEapplyBanca == 'yes'){
      //     catogoryCardData.push(element)
      //   }
      // } else {
      //   if (element.isEapply == 'yes' && element.isVisibleOnWebsite == 'yes' && !this.excludedCards.includes(element.name)) {
      //     catogoryCardData.push(element)
      //   } 
      // }
      
        // if (element.isEapply == 'yes' && element.isVisibleOnWebsite == 'yes' && !this.excludedCards.includes(element.name)) {
        //   catogoryCardData.push(element)
        // } else if(element.isEapplyBanca == 'yes') {
        //   console.log(element.isEapplyBanca);
        //   catogoryCardData.push(element)

        // }
        if(items.isEapplyBancaCatorgy ==true && element.isEapplyBanca == 'yes' && element.isVisibleOnWebsite == 'yes' && !this.excludedCards.includes(element.name)) {
          catogoryCardData.push(element);
        } else if(items.isEapplyBancaCatorgy ==false && element.isEapply == 'yes' && element.isVisibleOnWebsite == 'yes' && !this.excludedCards.includes(element.name)) {
          catogoryCardData.push(element);
        } else if(items.isEapplyCustomCatorgy ==true && items.isEapplyCustomCatorgy !=undefined && items.cards.cusotmCardsList) {
          //catogoryCardData.push(element);
          // items.forEach(el => {
          //   if(items.cusotmCardsList.length) {
          //     items.cusotmCardsList.forEach(cnt => {
          //         let dcrpath = cnt.card_dcr_path.replace('/shared/templatedata/product/card/data/sbi-card-en/','')
          //         if(dcrpath == el.path ) {
          //           catogoryCardData.push(element);
          //         } 
          //       })
          //    }                          
          //    })
         if(items.cards[0].details.cusotmCardsList.length >1) {
            items.cards[0].details.cusotmCardsList.forEach(cnt => {
              let dcrpath = cnt.card_dcr_path.replace('/shared/templatedata/product/card/data/sbi-card-en/','')
              if(element.path == dcrpath) {
                catogoryCardData.push(element);
              } 
            })
        } else {
            let dcrpath = items.cards[0].details.cusotmCardsList.card_dcr_path.replace('/shared/templatedata/product/card/data/sbi-card-en/','')
            if(element.path == dcrpath) {
              catogoryCardData.push(element);
              }  
          }


             
           
        }
        
    
    });
    return catogoryCardData;
  }
  showCards(items) {
    this.resetFlags();
    this.seletedCategory = items.name;
    this.knowMoreData = false;
    this.extraknowMoreData = [];
    this.selectedIndex = -1;
    if (items.name == 'All') {
      this.selectedCardData = this.totalCardsList;
      this.cardCount = this.selectedCardData.length;
      this.selectedCatoryName = 'All Cards';
    }
    else {
      this.selectedCardData = this.catogoryCardData(items);
      this.cardCount = this.selectedCardData.length;
      this.selectedCatoryName = items.name;
    }
    this.cardVisibleData = this.selectedCardData;
  }
  showKnowMore(items, pos) {
    this.resetFlags();
    if (this.selectedIndex == pos) {
      this.selectedIndex = -1;
    } else {
      this.selectedIndex = pos;
      this.knowMoreorder = this.getKnowMoreOrder(pos);
      this.updateOrder();
      this.selectedCardData = [...this.selectedCardData];
      this.knowMoreData = items;
      this.extraknowMoreData = false;
    }
  }
  updateOrder() {
    let elems:any = document.querySelectorAll('.re_card_box_.twolinetext');
    let index = 0, length = elems.length;
    for (; index < length; index++) {
      let knowmeindex = this.knowMoreorder;
      if (elems[index].style.order < knowmeindex) {
        elems[index].style.order = index + 1;
      } else if (elems[index].style.order == knowmeindex) {
        elems[index].style.order = +knowmeindex + 1;
      }

    }
  }

  getKnowMoreOrder(pos) {
    let desktopIndex = 3;
    let mobileIndex =2;
    let currentIndex = this.isMobile ? mobileIndex : desktopIndex;
    let openingIndex;
    if(pos < currentIndex)    
    openingIndex = currentIndex + 1;
    if(!this.isMobile) {
      if(pos == currentIndex) {
        openingIndex = pos + currentIndex +1;
      }
      else if(pos%currentIndex == 0) {
        openingIndex = pos + currentIndex +1;
      }
       
      else if (pos%currentIndex == 1)  {
         openingIndex = pos + 3;
        }
      else if (pos%currentIndex == 2) { 
        openingIndex = pos +2 ;
      }
    } else {
      if(pos%currentIndex == 0) {
        openingIndex = pos + currentIndex +1;        
      }
      else if (pos%currentIndex == 1)  {
         openingIndex = pos + 2;
        }     
    }
    return openingIndex;

  } 
  isAdded(carddata) {
    return (this.CompareCardData.indexOf(carddata) == '-1') ? true : false;
  }
  resetFlags() {
    this.selectedCardData = this.selectedCardData;
    this.selectedIndex = -1;
    this.knowMoreData = false;
    this.extraknowMoreData = false;
    this.viewMoreBtnVisible = true;
    this.viewMoreLessVisible = false; 
  }
  // loadQdeForm(dcrPath,cardname) {
  //   catalogue_card_click(cardname);
  //   this.catalogueService.referpartnerDcr = dcrPath;
  //   this.themeService.partnerDcr = dcrPath;   
  //   this.router.navigate(['./apply'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType ? true : false });
  //   this.sharedData.retrievedApplicationResponse = null;
  //   /* After Click of Apply */
  //   virtual_page_load(cardname,'sbi-card:eapply:eapplyform','Eapply');
  // }
  loadQdeForm(dcrPath,cardname) {
    console.log("cardname from catalogue refer ===>", cardname);
    catalogue_card_click(cardname);
    this.catalogueService.referpartnerDcr = dcrPath;
    this.themeService.partnerDcr = dcrPath;
    console.log("entered in swiftRedirect function ==>", dcrPath);
    let cardName;
    this.dcrCardUrlMapping = this.iw.geteapplyCardUpgradeMappingDCR();
    this.eligibleCardList = this.iw.getsprintApplicableCardList();
    this.dcrCardUrlMapping.forEach(item => {
      console.log("entered in foreach block from swiftRedirect");
      if(item.key_value == dcrPath) {
        cardName = item.key_name;
        console.log("selected card type =====>", cardName);
      }
    });
    this.eligibleCardList.forEach(item => {
      if(item.key_name == "AllCards") {
        this.redirectToSwift = true;
      }
      else if(item.key_name == cardName) {
        this.redirectToSwift = true;
      }
    });
    if (this.redirectToSwift) {
      if (!this.isBanca) {
        console.log("link should work from swiftRedirect function for card type MAX SBI card ==> ");
        let link = `${REDIRECT_SWIFT_URL}${cardName}?source=${this.themeString}&GEMID1=${this.gemId1}&GEMID2=${this.gemId2}`;
        // let link = `${REDIRECT_SWIFT_URL}${cardName}?referralcode=${this.catalogueService.referralCode}`;
        window.location.href = link;
      }
      else {
        console.log("NAvigate to apply from loadQdeForm from catlogue component");
        this.router.navigate(['./apply'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType ? true : false });
        this.sharedData.retrievedApplicationResponse = null;
        /* After Click of Apply */
        virtual_page_load(cardname, 'sbi-card:eapply:eapplyform', 'Eapply');
      }

    }
    else {
      if (cardname == 'AURUM Card') {
        window.location.href = "/eapply/campaign.page?path=personal/credit-cards/lifestyle/aurum-card.dcr&GEMID1=Mapp&theme=aurum";
      } else {
        console.log("NAvigate to apply from loadQdeForm from catlogue component");
        this.router.navigate(['./apply'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType ? true : false });
      }
      this.sharedData.retrievedApplicationResponse = null;
      /* After Click of Apply */
      virtual_page_load(cardname, 'sbi-card:eapply:eapplyform', 'Eapply');
    } 
 
    
  }
  closeKnowMe() {
    this.resetFlags();
    this.knowMoreData = false;
    this.updateOrder();
  }
  showExtraKnowMore() {
    this.viewMoreBtnVisible = false;
    this.viewMoreLessVisible = true;
    this.extraknowMoreData = !this.extraknowMoreData;
  }
  hideExtraKnowMore() {
    this.extraknowMoreData = false;
    this.viewMoreBtnVisible = true;
    this.viewMoreLessVisible = false;
  }
  updateIndex(index) {
    return index + 1;
  }
  removeHTMLTags(res) {
    return res.replace(/<[^>]*>/g, '');
  }
  
}